// extracted by mini-css-extract-plugin
export default {"image-container":"consultant-card_image-container__T53nD","container":"consultant-card_container__I4tOs","right-container":"consultant-card_right-container__-OCl2"};